import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIModelProvider } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { MODEL_PROVIDER_CONFIG_QUERY_KEY } from "ai-management/hooks/useModelProviderConfig";
import { emptyAuthFor } from "ai-management/providerAuth";
const useModelProviderMutations = () => {
  const queryClient = useQueryClient();
  const toCredentialsArg = (credentials) => {
    var _a;
    return {
      provider: credentials.provider,
      auth: (_a = credentials.auth) != null ? _a : emptyAuthFor(credentials.provider)
    };
  };
  const toSaveArg = (config) => {
    var _a;
    return {
      providers: config.providers.map(toCredentialsArg),
      default_provider: config.default_provider,
      default_model_id: (_a = config.default_model_id) != null ? _a : ""
    };
  };
  const save = useMutation({
    mutationFn: (config) => AIModelProvider.saveConfig(toSaveArg(config)),
    onSuccess: () => {
      UserNotification.success("Model provider configuration saved.");
      queryClient.invalidateQueries({ queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY });
    },
    onError: (error) => UserNotification.error(`Saving configuration failed: ${error}`)
  });
  const test = useMutation({
    mutationFn: (body) => AIModelProvider.test({
      provider: body.provider,
      model_id: body.model_id,
      credentials: toCredentialsArg(body.credentials)
    })
  });
  const remove = useMutation({
    mutationFn: () => AIModelProvider.deleteConfig(),
    onSuccess: () => {
      UserNotification.success("Model provider configuration deleted.");
      queryClient.invalidateQueries({ queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY });
    },
    onError: (error) => UserNotification.error(`Deleting configuration failed: ${error}`)
  });
  return { save, test, remove };
};
export default useModelProviderMutations;
